import { compose, withPropsOnChange, withState } from 'recompose';
import { connect } from 'react-redux';

import { LOCATIONS_ALL_ID } from '../constants';
import { t } from '../../../../../../modules/infra/i18n';

// Store translation key instead of calling t() at module level
const ALL_LOCATIONS_KEY = 'barber:brand_barber.location_selector.all_locations';

// Helper function to create allLocationsItem at runtime
const createAllLocationsItem = () => ({ label: t(ALL_LOCATIONS_KEY), value: LOCATIONS_ALL_ID });

export default compose(
  connect((state, ownProps) => {
    const shops = ownProps.barberShops;
    const allLocationsItem = createAllLocationsItem(); // ✅ t() called at runtime

    if (!shops.length) {
      return { locationSelectorOptions: [allLocationsItem] };
    }

    const allLocations = shops.length > 1 ? [allLocationsItem] : [];
    const locationSelectorOptions = allLocations.concat(shops.map(shop => ({
      label: shop.name,
      value: shop.id,
    })));

    return { locationSelectorOptions };
  }),
  withState('selectedLocation', 'setSelectedLocation', props =>
    (props.locationSelectorOptions.length ? props.locationSelectorOptions[0].value : '')
  ),
  withPropsOnChange(
    (prevProps, nextProps) => (
      prevProps.locationSelectorOptions.length !== nextProps.locationSelectorOptions.length
      || (
        // new barber with 1 shop is created => options go from ['all'] to ['shopId'] (but length doesn't change)
        prevProps.locationSelectorOptions.length
        && prevProps.locationSelectorOptions[0].value !== nextProps.locationSelectorOptions[0].value
      )
    ),
    (props) => {
      props.setSelectedLocation(props.locationSelectorOptions[0].value);
    },
  ),
);
